import React from "react";
import { Tooltip } from "antd";

interface ContentCellNowrapProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const ContentCellNowrap: React.FC<ContentCellNowrapProps> = ({ children, style }) => {
  const content =
    typeof children === "string" || typeof children === "number" ? children.toString() : "";

  return (
    <Tooltip title={content || undefined}>
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          ...style,
        }}
      >
        {children}
      </div>
    </Tooltip>
  );
};

export default ContentCellNowrap;
